"use strict";

if ("undefined" != typeof Shopify) {
  var searchTimeout;
  if (void 0 === dataLayer || !1 === dataLayer) var dataLayer = [];
  !function (jQuery) {
    if (!1 === jQuery || void 0 === jQuery) return !1;
    function trackReceipt(receiptObject) {
      !function () {
        var orderNumber = checkoutData.id,
          revenue = parseInt(jQuery("[data-checkout-payment-due-target]").data("checkout-payment-due-target")) / 100,
          tax = parseInt(jQuery("[data-checkout-total-taxes-target]").data("checkout-total-taxes-target")) / 100,
          shipping = parseInt(jQuery("[data-checkout-total-shipping-target]").data("checkout-total-shipping-target")) / 100;
        if (localStorage.getItem("trackedReceiptGa") == orderNumber) return !1;
        var object = {
          ecommerce: {
            purchase: {
              actionField: {
                id: orderNumber,
                affiliation: "Online Store",
                revenue: revenue,
                tax: tax,
                shipping: shipping
              },
              products: getCartProducts()
            }
          }
        };
        if (jQuery(".reduction-code__text").length > 0) {
          var promoCode = jQuery(".reduction-code__text").text().trim();
          object.ecommerce.purchase.actionField.coupon = promoCode;
        }
        dataLayer.push(object), localStorage.setItem("trackedReceiptGa", orderNumber);
      }();
      var orderMatch = jQuery(".os-order-number").text().trim().match(/\d+/g),
        orderNumber = null != orderMatch ? orderMatch[0] : null,
        revenue = parseInt(jQuery("[data-checkout-payment-due-target]").data("checkout-payment-due-target")) / 100,
        tax = parseInt(jQuery("[data-checkout-total-taxes-target]").data("checkout-total-taxes-target")) / 100,
        shipping = parseInt(jQuery("[data-checkout-total-shipping-target]").data("checkout-total-shipping-target")) / 100;
      if (void 0 !== receiptObject && (orderNumber = receiptObject.orderNumber, revenue = receiptObject.revenue, tax = receiptObject.tax, shipping = receiptObject.shipping), "" == orderNumber || null == orderNumber) {
        var xhttp = new XMLHttpRequest();
        return xhttp.open("GET", document.location.pathname, !0), xhttp.onreadystatechange = function () {
          if (4 == this.readyState && 200 == this.status) {
            var $response = jQuery(xhttp.responseText),
              _orderMatch = $response.find(".os-order-number").text().trim().match(/\d+/g);
            trackReceipt({
              orderNumber: null != _orderMatch ? _orderMatch[0] : null,
              revenue: parseInt($response.find("[data-checkout-payment-due-target]").data("checkout-payment-due-target")) / 100,
              tax: parseInt($response.find("[data-checkout-total-taxes-target]").data("checkout-total-taxes-target")) / 100,
              shipping: parseInt($response.find("[data-checkout-total-shipping-target]").data("checkout-total-shipping-target")) / 100
            });
          }
        }, void xhttp.send();
      }
      var awinTotal = revenue - shipping,
        awinTotalLessTax = awinTotal - tax,
        awinParts = getAwinCommissionGroup() + ":" + awinTotalLessTax;
      if (localStorage.getItem("trackedReceipt") == orderNumber) return !1;
      var object = {
        event: "secondaryCheckout",
        awin: {
          amount: awinTotal,
          channel: getAwinChannel(),
          orderRef: orderNumber,
          parts: awinParts,
          commission: getAwinCommissionGroup(awinTotalLessTax),
          currency: "GBP",
          test: 0
        }
      };
      if (jQuery(".reduction-code__text").length > 0) {
        var promoCode = jQuery(".reduction-code__text").text().trim();
        object.awin.voucher = promoCode;
      }
      !function (orderNumber, awinTotalLessTax) {
        var products = getCartProducts(),
          productLines = [],
          advertiserId = 6526;
        for (var i = 0; i < products.length; i++) {
          var product = products[i],
            priceStr = "" + product.price,
            tempArray = ["AW:P", advertiserId, orderNumber, product.id, product.name, parseFloat(priceStr.replace(",", "")), product.quantity, product.sku, getAwinCommissionGroup(awinTotalLessTax), ""];
          productLines.push(tempArray.join("|"));
        }
        var productLineData = productLines.join("\r\n"),
          $field = jQuery('<textarea wrap="physical" id="aw_basket">' + productLineData + "</textarea>"),
          $form = jQuery('<form name="aw_basket_form"></form>');
        $field.appendTo($form), $form.appendTo("body"), $form.hide(), function () {
          var time = new Date(),
            days = 730;
          time.setTime(+time + 864e5 * days), document.cookie = "awinc=true; expires=" + time.toGMTString() + "; path=/";
        }();
      }(orderNumber, awinTotalLessTax), dataLayer.push(object), localStorage.setItem("trackedReceipt", orderNumber), localStorage.removeItem("awc");
    }
    function getAwinChannel() {
      return void 0 !== localStorage.awc ? localStorage.awc : "aw";
    }
    function getAwinCommissionGroup(awinTotalLessTax) {
      var group,
        pregroup = "NEW";
      return (void 0 !== function (name) {
        var parts = "; ".concat(document.cookie).split("; ".concat(name, "="));
        if (2 === parts.length) return parts.pop().split(";").shift();
      }("awinc") || jQuery("[data-existing-customer]").length > 0) && (pregroup = "EXISTING"), group = awinTotalLessTax >= 1e3 ? "PURCHASE1000" : awinTotalLessTax >= 149.99 ? "PURCHASE999" : awinTotalLessTax >= 50 ? "PURCHASE149" : "PURCHASE50", "NEW" == pregroup && (group = group.replace("PURCHASE", "") + "NEW"), group;
    }
    function getCheckoutOption() {
      return "shipping_method" == getCheckoutLabel() ? jQuery('[name="checkout[shipping_rate][id]"]:checked').parents(".radio-wrapper").find(".radio__label__primary").data("shipping-method-label-title") : "payment_method" == getCheckoutLabel() ? jQuery('[name="checkout[payment_gateway]"]:checked').parents(".radio-wrapper").find(".radio__label__primary").text().trim() : void 0;
    }
    function getCheckoutStep() {
      switch (getCheckoutLabel()) {
        case "contact_information":
          return 2;
        case "shipping_method":
          return 3;
        case "payment_method":
          return 4;
      }
      if ("thank_you" === Shopify.Checkout.page) return 5;
    }
    function getCheckoutLabel() {
      return Shopify.Checkout.step;
    }
    function getCartProducts() {
      var products = [];
      if (isDraftOrder) {
        var productPrice = jQuery(".product__price:first").text().trim().replace("£", ""),
          product = {
            name: jQuery(".product__description__name:first").text(),
            category: "Draft Order Checkout",
            price: productPrice,
            quantity: 1
          };
        products.push(product);
      } else {
        var cartData = JSON.parse(localStorage.cartData);
        for (var i = 0; i < cartData.products.length; i++) {
          var _product = cartData.products[i],
            _product2 = {
              name: _product.name,
              id: _product.product_id,
              variant: _product.variant_id,
              quantity: _product.quantity,
              brand: _product.brand,
              sku: _product.sku,
              price: parseFloat(_product.price.replace(",", "")),
              category: getCategory(_product.product_id)
            };
          products.push(_product2);
        }
      }
      return products;
    }
    function getCategory(id) {
      return (null == localStorage.categories ? {} : JSON.parse(localStorage.categories))[id];
    }
    !function () {
      var channel = !1;
      null !== window.location.search.match("gclid=") && (channel = "google");
      null !== window.location.search.match("msclkid=") && (channel = "bing");
      null !== window.location.search.match("awc=") && (channel = "aw");
      null !== window.location.search.match("utm_source=mentionme") && (channel = "mentionme");
      null !== window.location.search.match("utm_medium=email") && (channel = "email");
      null !== window.location.search.match("utm_source=organic") && (channel = "organic");
      !1 !== channel && (localStorage.awc = channel);
    }(), void 0 !== Shopify.Checkout && function () {
      if ("thank_you" == Shopify.Checkout.page) return void trackReceipt();
      var object = {
        event: "checkout",
        ecommerce: {
          checkout: {
            actionField: {
              step: getCheckoutStep()
            },
            products: getCartProducts()
          }
        }
      };
      dataLayer.push(object), ["shipping_method", "payment_method"].indexOf(getCheckoutLabel()) > -1 && (jQuery(document).off("submit.checkout").on("submit.checkout", ".edit_checkout:not(.tracked):not(.gc-form)", function () {
        var object = {
          event: "checkoutOption",
          ecommerce: {
            checkout_option: {
              actionField: {
                step: getCheckoutStep(),
                option: getCheckoutOption()
              }
            }
          }
        };
        dataLayer.push(object);
      }), jQuery(document).on("change", "[data-shipping-methods] input", function (e) {
        var eventObject = {
          event: "DeliverySelection",
          eventCategory: "Checkout",
          eventAction: "Delivery Method",
          eventLabel: jQuery(this).parents(".radio-wrapper").find("[data-shipping-method-label-title]").data("shipping-method-label-title")
        };
        dataLayer.push(eventObject);
      }), jQuery(document).on("change", "[data-payment-method] input", function (e) {
        var eventObject = {
          event: "PaymentSelection",
          eventCategory: "Checkout",
          eventAction: "Payment Method",
          eventLabel: jQuery(this).parents(".radio-wrapper").find(".radio__label__primary").text().trim()
        };
        dataLayer.push(eventObject);
      }));
    }(), function () {
      var error = !1;
      jQuery(".notice--error:visible").length > 0 ? error = jQuery(".notice--error:visible").text().trim() : jQuery(".form-message--error:visible ul").length > 0 ? error = jQuery(".form-message--error:visible ul").text().trim() : jQuery(".field__message--error:visible").length > 0 && (error = jQuery(".field__message--error:visible").text().trim());
      0 != error && dataLayer.push({
        errorMessage: error
      });
    }(), function () {
      if ("/search" == window.location.pathname) {
        var object = {
          event: "searchTerm",
          eventCategory: "Search Tracking",
          eventAction: "Text Entered",
          eventLabel: window.location.search.split("q=")[1].split("&")[0]
        };
        dataLayer.push(object);
      }
      jQuery(document).on("track-quicksearch", function (e) {
        clearTimeout(searchTimeout), searchTimeout = setTimeout(function () {
          var object = {
            event: "quickSearch",
            eventCategory: "Search Tracking",
            eventAction: "Text Entered",
            eventLabel: jQuery(".search__input:visible").val()
          };
          dataLayer.push(object);
        }, 1e3);
      });
    }(), "undefined" != typeof dataLayerData && void 0 !== dataLayerData.product && void 0 !== dataLayerData.product.id && gaProductView();
  }(window.jQuery ? window.jQuery : !(!window.Checkout || !window.Checkout.$) && window.Checkout.$);
}
